import {
  constants,
  mediaQueryStyles as mq,
  typographyStyles,
} from '@newsela/angelou';

import {breakpointSwitch} from '../../style';

const {
  colors: {ui},
} = constants;
const {textXSObj: text4Obj} = typographyStyles;
const smallBreakpointSwitch = mq.mediaQuery.downTo(
  constants.breakpoints.Breakpoints.sm
);

export const listItemLinkStyle = {
  outlineOffset: '-5px',
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  padding: '8px 24px',
  margin: '8px 0',
  color: ui.greyDark[700],
  ':hover, :focus, :focus-within': {
    color: ui.greyDark[700],
    textDecoration: 'none',
    backgroundColor: ui.greyExtraLight[700],
    '*': {
      color: ui.greyDark[500],
      stroke: ui.greyDark[500],
    },
  },
  [smallBreakpointSwitch]: {
    outlineOffset: '-10px',
  },
};

export const menuHeadingStyle = {
  color: ui.grey[500],
  ...text4Obj,
  lineHeight: '1.35',
  letterSpacing: '0.08em',
  borderTop: `1px ${ui.greyLight[100]} solid`,
  borderBottom: `1px ${ui.greyLight[100]} solid`,
  fontFamily: 'Circular,Helvetica,Arial,sans-serif',
  fontWeight: 'bold',
  padding: '8px 24px 8px 16px',
  margin: '8px 0;',
  ':hover': {
    backgroundColor: ui.white[500],
  },
  ':first-of-type': {
    marginTop: 0,
    borderTop: 'none',
  },
  [breakpointSwitch]: {
    paddingLeft: '24px',
  },
};

export const marginZero = {
  margin: 0,
};

export const marginBottomOverride = {
  [breakpointSwitch]: {
    marginBottom: '8px',
  },
};

export const ulPaddingOverride = {
  padding: 0,
};

export const listBufferBottom = {
  backgroundColor: ui.white['500'],
  width: '100%',
  borderRadius: '4px',
};
